import React from "react";

const AppTabs = ({
  tabs = [],
  value,
  onChange,
  className = "",
}) => {
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full bg-gray-100 p-1 ${className}`}
    >
      {tabs.map((tab) => {
        const isActive = value === tab.value;
        const activeClassName = tab.activeClassName || "bg-primary text-white shadow";
        const inactiveClassName = tab.inactiveClassName || "text-gray-600";
        const hoverClassName = tab.hoverClassName || "hover:bg-gray-200 hover:text-gray-900";

        return (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`
              px-4 py-1.5 text-sm font-medium rounded-full transition
              ${isActive ? activeClassName : `${inactiveClassName} ${hoverClassName}`}
            `}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default AppTabs;
